import { types } from '../reducers/mainHubConfigReducer';

// eslint-disable-next-line import/prefer-default-export
export const getMainHubConfigs = (values) => ({
  type: types.GET,
  payload: values,
});

export const getSportRoomEntryPoint = (values) => ({
  type: types.GET,
  payload: values,
});

export const getWhiteLabelProName = (values) => ({
  type: 'MAINHUB_NAME',
  payload: values,
});



